var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWidgets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.67687 0.4375H1.88563C1.08585 0.4375 0.4375 1.08585 0.4375 1.88563V4.67687C0.4375 5.47665 1.08585 6.125 1.88563 6.125H4.67687C5.47665 6.125 6.125 5.47665 6.125 4.67687V1.88563C6.125 1.08585 5.47665 0.4375 4.67687 0.4375Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1144 0.4375H9.32312C8.52335 0.4375 7.875 1.08585 7.875 1.88563V4.67687C7.875 5.47665 8.52335 6.125 9.32312 6.125H12.1144C12.9142 6.125 13.5625 5.47665 13.5625 4.67687V1.88563C13.5625 1.08585 12.9142 0.4375 12.1144 0.4375Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67687 7.875H1.88563C1.08585 7.875 0.4375 8.52335 0.4375 9.32312V12.1144C0.4375 12.9142 1.08585 13.5625 1.88563 13.5625H4.67687C5.47665 13.5625 6.125 12.9142 6.125 12.1144V9.32312C6.125 8.52335 5.47665 7.875 4.67687 7.875Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7188 13.5625C12.2893 13.5625 13.5625 12.2893 13.5625 10.7188C13.5625 9.14819 12.2893 7.875 10.7188 7.875C9.14819 7.875 7.875 9.14819 7.875 10.7188C7.875 12.2893 9.14819 13.5625 10.7188 13.5625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgets);
export default __webpack_public_path__ + "static/media/widgets.a0a375312cbcfa986d9df0c8d82afb89.svg";
export { ForwardRef as ReactComponent };